import { KoButton, KoForm,  KoLoader, KoModal, KoPagination, KoTable, KoText, KoTitle, KoToast, KoTooltips, Upload } from "packages";
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import KoToolBar from "shared/components/toolbar";
import {DevelopmentAPI } from "pages/workspace/process/development/development.service";
import styles from './testcases.module.scss';
import { LEV_ITEMS_COLUMNS, TESTCASE_COLUMNS } from './constant';
import TestCaseCrud from "./crud";
import { getCookie, setCookie } from "shared/utils/cookies";
import csvTemplate from './sample.csv';
const TestCases = (props) => {
  const [totalCount, setTotalCount] = useState(100);
  const [testCasesList, settestCasesList] = useState();
  const [openImport, setOpenImport] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [errors, setErrors] = useState();

  // const [, settestCasesListTicket] = useState([]);
  const [isOpen, setModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [form] = KoForm.useForm();
  const {workspaceId} = useParams();
  const [pagination, setPagination] = useState({
    size: 10,
    page: 1
  });
 
  useEffect(() => {
    getTestCases();
  }, []);

  const getTestCases = () => {
    settestCasesList();
    setLoading(true);
    DevelopmentAPI.getTestCases(workspaceId, pagination).then(
      (data) => {
        setLoading(false);
        settestCasesList(data?.data);
        setTotalCount(data?.totalCount);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const onSearchText = (text) => {
    let q = pagination;
    if (text) {
      q['search'] = text;
    }else {
      delete q?.['search'];
    }
    getTestCases(q);
  };

  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getTestCases(q);
  };

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
    getTestCases(pQuery);
  };


  const handleFinish = (values => {
    setLoading(true);
    DevelopmentAPI.createOrUpdateTestcase(values, currentRecord?.caseId, workspaceId).then(
      (data) => {
        getTestCases();
        setLoading(false);
        setModal(false);
        form.resetFields();
        KoToast.success(`Testcase ${currentRecord?.caseId ? 'updated':'created'} Successfully`);

      },

      (err) => {
        setLoading(false);
      }
    );
  });

  const handleDelete = () => {
    setLoading(true);
    DevelopmentAPI.deleteTestcase(currentRecord?.caseId, workspaceId).then(
      (data) => {
        setLoading(false);
        setDeleteModal(false);
        KoToast.success("Testcase Deleted Successfully");
        getTestCases();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onCellClick=(row, colName)=>{
    setCurrentRecord(row);
    if(colName === 'ticketId') {
      const url = `/open/ticket/${getCookie("accountId")}/${row?.workspace}/${row?.ticketId}`;
      window.open(url, '_blank');
    }
  };

  const onHandelSprint = (e, row) => {
    setCurrentRecord(row);
    setDeleteModal(true);
  };
  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`}>
        <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={(e) => onHandelSprint(e, row)} />
        </KoTooltips>
        <KoTooltips title={'Add Test Case'}>
          <KoButton onClick={() => {setCurrentRecord(row); setModal(true);}} className={'btn'} iconBtn={true}  icon={<KoIcon width={18} height={18} name={'PlusFilled'} />} />
        </KoTooltips>
      </div>;
    }
  }];

  // const getTestCasesBYId = (ticketId) => {
  //   DevelopmentAPI.getTestCasesByTiocket(ticketId, workspaceId).then(
  //     (data) => {
  //       settestCasesListTicket(data?.data);
  //     },
  //     (err) => {
  //     }
  //   );
  // };

  const onRowExpand = (expanded, record) => {
    console.log(record);
    setExpandedRowKeys((prevKeys) => (
      expanded ? [...prevKeys, record.key] : prevKeys.filter((key) => key !== record.key)
    ));
    // getTestCasesBYId(record?.ticketId);
  };


  const handleUpload = () => {
    if (!fileList.length) {
      KoToast.error("Please select a file to upload.");
      return;
    }
  
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });
  
    setLoading(true);
  
    fetch(
        `${process.env.REACT_APP_PROXY_HOST}/api/v1/taskplanner/import/testcases`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${getCookie("accessToken")}`,
            workspace: String(workspaceId)
          }
        }
    )
      .then(async(res) => {
        const data = await res.json(); // ✅ parse JSON once
  
        if (!res.ok) {
          setErrors(data['data']);
          throw new Error(data?.message || "Upload failed.");
        }
  
          // ✅ SET jobId IN COOKIE
        if (data?.jobId) {
          setCookie("jobId", data.jobId);
        }
  
        return data;
      })
      .then(() => {
        KoToast.success(
          "Cases imported successfully. Non-sprint tickets moved to backlog."
        );
        setErrors();
        setOpenImport(false);
        setFileList([]);
      })
      .catch((error) => {
        console.error("Upload error:", error);
        KoToast.error(error.message || "Upload failed.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  
  
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = csvTemplate;
    link.setAttribute("download", "testcase_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList
  };

  
  return (
    <>
      {isLoading && <KoLoader />}
      <div className={`${styles.wrapper} tableCard`}>
        <KoToolBar
          title={'Test Cases'}
          search={{ visible: true, onChange: (e) => { onSearchText(e); }, placeholder: 'Search by ticket id' }}
          filter={{ visible: false }}
          buttonList={[{
            label: 'Import',
            type: 'default',
            icon: <KoIcon color="#FFF" name="ImportOutlined" width={14} height={14} />, onClick: () => setOpenImport(!openImport)
          }]}
        />
        <KoTable
          rowKey="ticketId"
          className="testCaseTable"
          onSort={onSort}
          onCellClick={onCellClick}
          data={{ columns: LEV_ITEMS_COLUMNS, rows: testCasesList }}
          extraColumnsRight={columnsRight}
          maxHeight={111}
          expandable={{
            expandable: true,
            expandedRowRender: (record) =>
              <KoTable
                rowKey="caseId"
                data={{
                  columns: TESTCASE_COLUMNS,
                  rows: record?.testCases
                }}
                maxHeight={500}
                onRowExpand={onRowExpand}
                expandedRowKeys={expandedRowKeys}
              />,
            rowExpandable: (record) =>
              Array.isArray(record.children) && record.children.length > 0
          }}
        />

        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
        {isOpen && <TestCaseCrud
          isOpen={isOpen}
          form={form}
          handleFinish={handleFinish}
          setCurrentRecord={()=>setCurrentRecord()}
          setModal={()=>setModal(false)}
          ticketId={currentRecord?.ticketId} />}
        <KoModal
          title={`Delete ${currentRecord?.caseId?.toUpperCase()} Testcase `}
          centered
          open={isOpenDelete}
          afterClose={() => {setCurrentRecord();}}
          handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
          onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
          width={580}
        // maskClosable={false}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
            <KoButton key='delete' loading={isLoading}color="danger" variant="solid"  type='primary' label='Delete' onClick={() => handleDelete()} />
          ]}
        >
          <div className={styles.delWrapper}>
            <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
            <KoText text={`Do you wish to proceed?`} />
          </div>
        </KoModal>
      </div>

      <KoModal
        title={`Import issues from CSV`}
        centered
        open={openImport}
        handleOk={() => {setOpenImport(false); setErrors(); setFileList([]);}}
        onClose={() => {setOpenImport(false); setErrors(); setFileList([]);}}
        // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setOpenImport(false); setErrors(); setFileList([]);}} />,
          <KoButton key='upload' onClick={() => handleUpload()}  type='primary' label={ `Import`}/>
        ]}
      >

        <div className={styles.modalContent}>
          {isLoading && <KoLoader/>}
          <KoText text="Download CSV Template" className={styles.templateText} onClick={handleDownloadTemplate} />
          <Upload {...uploadProps} accept=".csv" className={styles.uploadWrapper}>
            <div className={styles.upload}>
              <KoIcon width={24} height={24} name="ImportOutlined" />
              {fileList.length === 0 && <div className={styles.upload}>
                <KoText text="Click to upload the CSV file" />
              </div>}
            </div>
          </Upload>

          {
            errors &&
            <div className={styles.errorWrapper}>
              <KoTitle level={5} text="Upload information" />
              <div className={styles.errorRow}>
                <KoText text={`Created Test Cases: ${errors?.success ? errors?.success : 0}`} className={styles.success} />
                <KoText text={`Error Test Cases: ${errors?.errors ? errors?.errors : 0}`} className={styles.error} />
                <KoText text={`Failed Test Cases: ${errors?.failed ? errors?.failed : 0}`} className={styles.error} />
                <KoText text={`Total Test Cases: ${errors?.total ? errors?.total : 0}`} className={styles.total} />
              </div>
              <ul>
                {
                  errors?.errors?.map((error, index) => (
                    <li key={index}>
                      <KoText text={error} className={styles.errorText} />
                    </li>
                  ))
                }
              </ul>
            </div>
          }
        </div>
        
      </KoModal>
    </>
  );
};

export default TestCases;